import { useState } from "react";
import { PROJECTS } from "../data.js";

export default function Projects() {
  const [i, setI] = useState(0);
  const p = PROJECTS[i];
  return (
    <div className="wrap split">
      <div>
        <h2>Recent work</h2>
        <p className="lede">Four projects and the materials we chose for each.</p>
        <ul className="plist">
          {PROJECTS.map((q, k) => (
            <li key={q.name}>
              <button type="button" className="pbtn" aria-pressed={k === i} onClick={() => setI(k)}>
                <span className="t">{q.name}</span>
                <span className="s">{q.kind}</span>
              </button>
            </li>
          ))}
        </ul>
      </div>
      <article className="panel" aria-live="polite">
        <h3>{p.name}</h3>
        <p className="sub">{p.kind}</p>
        <p className="note">{p.note}</p>
        <dl className="specs">
          <div><dt>Size</dt><dd>{p.size}</dd></div>
          <div><dt>Build time</dt><dd>{p.time}</dd></div>
          <div><dt>Finished</dt><dd>{p.year}</dd></div>
        </dl>
        <h4>Materials</h4>
        <ul className="mats">
          {p.mats.map(([name, color]) => (
            <li key={name}><span className="sw" style={{ background: color }} />{name}</li>
          ))}
        </ul>
      </article>
    </div>
  );
}
